/**
 * Resolves once every image is downloaded and decoded, so showing it can't flash or shift the layout. An image
 * that fails to load resolves too: the page still turns, and its broken image shows the problem.
 *
 * @param {string[]} urls
 * @returns {Promise<void>}
 */
export function loadImages(urls) {
  return Promise.all(urls.map(url => new Promise(resolve => {
    const image = new Image();
    image.onload = () => image.decode().then(resolve, resolve);
    image.onerror = resolve;
    image.src = url;
  }))).then(() => undefined);
}
